import * as Axios from "axios";

import AccountListResponse from "@/domain/accountListResponse";

export default class AccountService {
  constructor(private accountServer, private apiKey) {}

  public async listAccounts(
    token: string
  ): Promise<AccountListResponse> {
    const apiConfig: Axios.AxiosRequestConfig = {
      baseURL: this.accountServer,
      url: `/v1/subscriptions/@me`,
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
    };

    try {
      const response = await Axios.default.request<any>(apiConfig);
      return response.data as AccountListResponse;
    } catch (error: any) {
      console.log(error.message);
      throw error;
    }
  }
}
